import { RootState } from "redux/rootReducer";
import { Party } from "types/party";

export const currentPartySelector = (state: RootState): Party | null =>
  state.party.current;
